import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-info text-light py-4 mt-auto">
      <Container>
        <Row>
          <Col md={6}>
            <p>&copy; 2023 APresentMatch. All rights reserved.</p>
          </Col>
          <Col md={6} className="text-md-end">
            <a href="/impressum" className="text-light mx-2">Impressum</a>
            <a href="/data-protection" className="text-light mx-2">Datenschutz</a>
            <a href="/contact" className="text-light mx-2">Kontaktiere uns</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;